export const HTTP_204_NO_CONTENT = 204

// DRF's settings.NON_FIELD_ERRORS_KEY default — the dict key under which non-field validation errors are returned.
export const NON_FIELD_ERRORS = "__all__"
